
export class BannerMessageDetails {
  bannerAuto: number;
  startDate: Date;
  endDate: Date;
  title: string;
  body: string;
  icon: string;
  severity: BannerMessageSeverity;
  location: BannerMessageLocation;
  disabled: boolean;
  hideable: boolean;
  displayPriority: number;
  hiddenPeriod: number;

  private _hidden: boolean = false;
  get hidden(): boolean {
    return this._hidden;
  }
  set hidden(value: boolean) {
    if (this.hideable) {
      this._hidden = value;
    } else {
      this._hidden = false;
    }
  }
}

export enum BannerMessageSeverity {
  info = 0,
  warning = 1,
  critical = 2,
}

export enum BannerMessageLocation {
  all = 99,
  root = 0,
  login = 1,
  landing = 2,
}

export enum BannerMessageTargetApplication {
  any = 0,
  elicensing = 1,
  data = 2,
  login = 3
}
